<template>
  <div class="Container">
    <h2 class="ViewHeading">Service Requests</h2>
    <div class="Container">
      <b-container>
        <b-row>
          <b-col>
            <br />
          </b-col>
        </b-row>

        <!--  <b-row>
          <b-col cols="4" md="4">
            <h4 id="HeadText">Open Service Requests</h4>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" md="8"
            ><p>
              Use fields below to filter Requests
            </p></b-col
          >
        </b-row>
        <b-row>
          <b-col cols="6" md="4"> </b-col>
        </b-row>
        <b-row>
          <b-col cols="4" md="4">
            <label for="RequestType">Original Request:</label>
            <select
              name="RequestType"
              v-model="RequestType"
              id="RequestType"
              @focus="modal = false"
              required
            >
              <option value=""></option>
              <option value="Alarm">Alarm</option>
              <option value="Error">Error</option>
              <option value="SupportRequest">Support Request</option>
            </select>
          </b-col>
          <b-col cols="4" md="4">
            <label for="RequestStatus">By Status:</label>
            <select
              name="RequestStatus"
              v-model="RequestStatus"
              id="RequestStatus"
              @focus="modal = false"
              required
            >
              <option value=""></option>
              <option>New</option>
              <option>Under Review</option>
              <option>Responded</option>
              <option>In Progress</option>
              
            </select>
          </b-col>
          <b-col cols="4" md="4">
            <label for="RequestTeam">By Team:</label>
            <select
              name="RequestTeam"
              v-model="RequestTeam"
              id="RequestTeam"
              @focus="modal = false"
              required
            >
              <option value=""></option>
              <option>IT Support</option>
              <option>Maintenance</option>
            </select>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm>
            <button class="button" v-on:click="SubmitFilter()">Filter</button>
            <button class="button" v-on:click="resetValue()">Clear</button>
          </b-col>
        </b-row> -->
      </b-container>
      <b-modal
        id="newticket"
        hide-footer
        lazy
        content-class="Modal"
        header-bg-variant="light"
        footer-bg-variant="light"
        title="New Support Ticket"
        ok-only
      >
        <b-card
          border-variant="dark"
          align="center"
          header-bg-variant="secondary"
          footer-tag="footer"
        >
          <template #header>
            <h4>Raise a Support Request</h4>
          </template>
          <b-card-sub-title>
            Use this form to submit any incidents, problems or support requests
          </b-card-sub-title>
          <br />
          <b-card-sub-title>
            Please complete below details
          </b-card-sub-title>
          <br />

          <b-card>
            <b-col cols="12">
              <label>Full Name</label>
            </b-col>
            <input
              id="reqraised"
              type="text"
              placeholder="Request Raised by"
              v-model="userID"
              required
              :readonly="true"
              @focus="modal = false"
            />
            <br />
            <b-col cols="12"><label>Contact Email</label></b-col>
            <input
              id="contactemail"
              maxlength="90"
              type="email"
              placeholder="User Email Address"
              v-model="UserEmail"
              @focus="modal = false"
              required
            />
            <b-col cols="12"><label for="">Request Type</label></b-col>
            <select
              name="RequestDrop"
              v-model="RequestDrop"
              id="RequestDrop"
              @focus="modal = false"
              required
            >
              <option select disabled value=""></option>
              <option>Clarence Software Support</option>
              <option>Maintenance Support</option>
            </select>
            <b-col cols="12"><label for="">Location</label></b-col>
            <input
              type="text"
              placeholder="Location"
              v-model="this.userLocation"
              required
              :readonly="true"
              @focus="modal = false"
            />
            <br />
          </b-card>

          <br />
          <b-card>
            <b-row>
              <b-form-radio-group
                v-model="selected"
                :options="optionsUrgency"
                class="mb-3"
                value-field="item"
                text-field="name"
                disabled-field="notEnabled"
                @focus="modal = false"
              ></b-form-radio-group>
            </b-row>
            <br />
            <b-col cols="12"
              ><label for="">
                Please describe in as much detail as possible the reason for the
                request. (1000 Character Max)</label
              ></b-col
            >

            <textarea
              class="supportTextArea"
              v-model="message"
              placeholder="Description"
              rows="6"
              cols="45"
              @focus="modal = false"
              maxlength="1000"
            ></textarea>
          </b-card>
          <br />
          <b-button
            variant="outline-info"
            v-on:click="
              checkmodal(
                checkedactions,
                StatusUpdate,
                messageforcontact,
                ServiceAssign,
                ServiceType
              )
            "
          >
            Submit
          </b-button>
          <b-button variant="outline-info" v-on:click="resetSupportActions()">
            Reset
          </b-button>
        </b-card>
      </b-modal>
      <div class="Container">
        <p>Current Open Requests for User</p>
        <!-- <b-pagination
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
          aria-controls="Requesttable"
        ></b-pagination>
        <b-table
          id="RequestTable"
          :items="this.items"
          :fields="this.UserHeaders"
          empty-text="You currently dont have any open support requests"
          :per-page="perPage"
          :current-page="currentPage"
          no-border-collapse
          hover
          show-empty
          responsive
          small
          sticky-header
        >
          <template v-slot:empty="scope">
            <h4>{{ scope.emptyText }}</h4>
          </template>
          <template v-slot:cell(Action)="{ item }">
            <b-button
              variant="outline-info"
              v-on:click="
                showActionModal(
                  item[0],
                  item[1],
                  item[3],
                  item[4],
                  item[7],
                  item[8],
                  item[9]
                )
              "
            >
              Action
            </b-button>
          </template>
        </b-table> -->

        <!-- FAKE TABLE BELOW -->

        <div id="Table">
          <!-- <h4>Scheduled Tests</h4> -->
          <div>
            <b-table
              sticky-header
              no-border-collapse
              responsive
              :items="scheduleditems"
              :fields="scheduledfields"
              hover
              small
            >
              <template v-slot:cell(Modify)="{ item }">
                <b-button
                  variant="outline-info"
                  v-on:click="modifyTestBooking(item)"
                  >Modify</b-button
                >
              </template>
            </b-table>
          </div>
        </div>

        <b-modal
          ref="ModifyServiceRequest"
          id="ModifyServiceRequest"
          hide-footer
          title="Modify"
          content-class="Modal"
          lazy
          header-bg-variant="light"
          footer-bg-variant="light"
        >
          <b-card
            border-variant="dark"
            align="center"
            header-bg-variant="secondary"
            footer-tag="footer"
          >
            <template #header>
              <h4 class="">
                Service ID: {{ ServiceID }} <br />
                Location: Ward Five
              </h4>
              <h4 class="">
                Service Description: 6 Monthly <br />
                Service Type: Routine C-1 Service
              </h4>
            </template>

            <b-card>
              <b-row>
                <b-col><label for="">Reschedule Date</label></b-col>
              </b-row>
              <b-row>
                <b-col
                  ><b-form-datepicker v-model="pickedDate"></b-form-datepicker
                ></b-col>
              </b-row>
              <br />
              <b-row>
                <b-col><label for="">Reschedule Time</label></b-col>
              </b-row>
              <b-row>
                <b-col
                  ><b-form-timepicker value="09:30:00"></b-form-timepicker
                ></b-col>
              </b-row>
              <!-- <b-button
                  block
                  variant="outline-info"
                  id="ChangeAssignee"
                  value="ChangeAssignee"
                  v-model="checkedactions"
                  v-b-toggle.ChangeAssignee
                >
                  Change Assignee</b-button
                > -->

              <!-- <b-button
                  block
                  variant="outline-info"
                  id="UpdateStatus"
                  value="StatusUpdate"
                  v-model="checkedactions"
                  v-b-toggle.UpdateStatus
                >
                  Change Status
                </b-button> -->

              <!-- <b-button
                  block
                  variant="outline-info"
                  type="checkbox"
                  id="closeTicket"
                  value="CloseTicket"
                  v-model="checkedactions"
                  v-b-toggle.CloseTicket
                  >Close Ticket
                </b-button> -->
            </b-card>

            <!-- <ul>
              <li id="check">
                <input
                  type="checkbox"
                  id="ChangeAssignee"
                  value="ChangeAssignee"
                  v-model="checkedactions"
                />
                <label for="ChangeAssignee">Change Assignee</label>
              </li>
              <li id="check">
                <input
                  type="checkbox"
                  id="UpdateStatus"
                  value="UpdateStatus"
                  v-model="checkedactions"
                />
                <label for="UpdateStatus">Change Status</label>
              </li>
              <li id="check">
                <input
                  type="checkbox"
                  id="closeTicket"
                  value="CloseTicket"
                  v-model="checkedactions"
                />
                <label for="closeTicket">Close Ticket</label>
              </li>
            </ul> -->

            <!-- <div v-if="checkedactions.includes('ChangeAssignee')">
              <label for="ServiceAssign">Assign To: </label>
              <select
                name="ServiceAssign"
                v-model="ServiceAssign"
                id="ServiceAssign"
              >
                <option value=""></option>
                <option>Maintenance</option>
                <option>IT Support</option>
              </select>
            </div>
            <div v-if="checkedactions.includes('UpdateStatus')">
              <p>Select new status for request</p>
              <label for="StatusUpdate">Updated Status</label>
              <select
                name="StatusUpdate"
                v-model="StatusUpdate"
                id="StatusUpdate"
              >
                <option value=""></option>
                <option>Under Review</option>
                <option>Responded</option>
                <option>In Progress</option>
                <option>Completed</option>
              </select>
            </div>
            <div v-if="checkedactions.includes('CloseTicket')">
              <p>Are you sure you want to close this ticket?</p>
              <b-form-radio-group
                v-model="CloseTicketSelection"
                :options="options"
                class="mb-3"
                value-field="item"
                text-field="name"
                disabled-field="notEnabled"
              ></b-form-radio-group>
              <div v-if="CloseTicketSelection == 'Yes'">
                <p>Please select a reason for Closure</p>
                <select
                  name="ClosureReason"
                  v-model="ClosureReason"
                  id="ClosureReason"
                >
                  <option value=""></option>
                  <option>Cancelled</option>
                  <option>No Longer Needed</option>
                </select>
              </div>
            </div> -->
            <br />
            <div>
              <b-button variant="outline-info" v-on:click="checkmodal()">
                Submit
              </b-button>
              <b-button variant="outline-info" v-on:click="resetModalActions()">
                Reset
              </b-button>
            </div>
          </b-card>
        </b-modal>

        <b-modal
          ref="ServiceActionModal"
          id="ServiceActionModal"
          hide-footer
          title="Service Action Form"
          content-class="Modal"
          lazy
          header-bg-variant="light"
          footer-bg-variant="light"
        >
          <b-card
            border-variant="dark"
            align="center"
            header-bg-variant="secondary"
            footer-tag="footer"
          >
            <template #header>
              <h4 class="">
                Ticket ID: {{ TicketobeActioned }} - Unit ID:
                {{ UnitAction }}
              </h4>
              <h4 class="">
                Status: {{ Status }} - Assigned To:
                {{ TicketAssignedTo }}
              </h4>
              <h4 class="">Raised By: {{ TicketRaisedBy }}</h4>
            </template>
            <b-card-sub-title class="mb-2"
              >Reason: {{ Reason }}</b-card-sub-title
            >
            <br />

            <b-card>
              <!-- <b-button
                  block
                  variant="outline-info"
                  id="ChangeAssignee"
                  value="ChangeAssignee"
                  v-model="checkedactions"
                  v-b-toggle.ChangeAssignee
                >
                  Change Assignee</b-button
                > -->
              <b-row>
                <b-col cols="3">
                  <input
                    type="checkbox"
                    id="ChangeAssignee"
                    value="ChangeAssignee"
                    v-model="checkedactions"
                    v-b-toggle.ChangeAssignee
                  />
                </b-col>
                <b-col cols="6">
                  <label for="ChangeAssignee">Change Assignee</label>
                </b-col>
              </b-row>
              <b-collapse id="ChangeAssignee">
                <b-card-body>
                  <b-card-sub-title>Assign To: </b-card-sub-title>
                  <br />
                  <select
                    name="ServiceAssign"
                    v-model="ServiceAssign"
                    id="ServiceAssign"
                  >
                    <option value=""></option>
                    <option>Maintenance</option>
                    <option>IT Support</option>
                  </select>
                </b-card-body>
              </b-collapse>

              <!-- <b-button
                  block
                  variant="outline-info"
                  id="UpdateStatus"
                  value="StatusUpdate"
                  v-model="checkedactions"
                  v-b-toggle.UpdateStatus
                >
                  Change Status
                </b-button> -->
              <b-row>
                <b-col cols="3">
                  <input
                    type="checkbox"
                    id="UpdateStatus"
                    value="UpdateStatus"
                    v-model="checkedactions"
                    v-b-toggle.UpdateStatus
                  />
                </b-col>
                <b-col cols="6">
                  <label for="UpdateStatus">Change Status</label>
                </b-col>
              </b-row>
              <b-collapse id="UpdateStatus">
                <b-card-body>
                  <b-card-sub-title>
                    Select new status for request
                  </b-card-sub-title>
                  <br />
                  <select
                    name="StatusUpdate"
                    v-model="StatusUpdate"
                    id="StatusUpdate"
                  >
                    <option value=""></option>
                    <option>Under Review</option>
                    <option>Responded</option>
                    <option>In Progress</option>
                    <option>Completed</option>
                  </select>
                </b-card-body>
              </b-collapse>
              <!-- <b-button
                  block
                  variant="outline-info"
                  type="checkbox"
                  id="closeTicket"
                  value="CloseTicket"
                  v-model="checkedactions"
                  v-b-toggle.CloseTicket
                  >Close Ticket
                </b-button> -->
              <b-row>
                <b-col cols="3">
                  <input
                    type="checkbox"
                    id="closeTicket"
                    value="CloseTicket"
                    v-model="checkedactions"
                    v-b-toggle.CloseTicket
                  />
                </b-col>
                <b-col cols="6">
                  <label for="closeTicket">Close Ticket</label>
                </b-col>
              </b-row>
              <b-collapse id="CloseTicket">
                <b-card-body>
                  <b-card-sub-title>
                    Are you sure you want to close this ticket?
                  </b-card-sub-title>
                  <br />
                  <b-form-radio-group
                    v-model="CloseTicketSelection"
                    :options="options"
                    class="mb-3"
                    value-field="item"
                    text-field="name"
                    disabled-field="notEnabled"
                  ></b-form-radio-group>
                  <div v-if="CloseTicketSelection == 'Yes'">
                    <p>Please select a reason for Closure</p>
                    <select
                      name="ClosureReason"
                      v-model="ClosureReason"
                      id="ClosureReason"
                    >
                      <option value=""></option>
                      <option>Cancelled</option>
                      <option>No Longer Needed</option>
                    </select>
                  </div>
                </b-card-body>
              </b-collapse>
            </b-card>

            <!-- <ul>
              <li id="check">
                <input
                  type="checkbox"
                  id="ChangeAssignee"
                  value="ChangeAssignee"
                  v-model="checkedactions"
                />
                <label for="ChangeAssignee">Change Assignee</label>
              </li>
              <li id="check">
                <input
                  type="checkbox"
                  id="UpdateStatus"
                  value="UpdateStatus"
                  v-model="checkedactions"
                />
                <label for="UpdateStatus">Change Status</label>
              </li>
              <li id="check">
                <input
                  type="checkbox"
                  id="closeTicket"
                  value="CloseTicket"
                  v-model="checkedactions"
                />
                <label for="closeTicket">Close Ticket</label>
              </li>
            </ul> -->

            <!-- <div v-if="checkedactions.includes('ChangeAssignee')">
              <label for="ServiceAssign">Assign To: </label>
              <select
                name="ServiceAssign"
                v-model="ServiceAssign"
                id="ServiceAssign"
              >
                <option value=""></option>
                <option>Maintenance</option>
                <option>IT Support</option>
              </select>
            </div>
            <div v-if="checkedactions.includes('UpdateStatus')">
              <p>Select new status for request</p>
              <label for="StatusUpdate">Updated Status</label>
              <select
                name="StatusUpdate"
                v-model="StatusUpdate"
                id="StatusUpdate"
              >
                <option value=""></option>
                <option>Under Review</option>
                <option>Responded</option>
                <option>In Progress</option>
                <option>Completed</option>
              </select>
            </div>
            <div v-if="checkedactions.includes('CloseTicket')">
              <p>Are you sure you want to close this ticket?</p>
              <b-form-radio-group
                v-model="CloseTicketSelection"
                :options="options"
                class="mb-3"
                value-field="item"
                text-field="name"
                disabled-field="notEnabled"
              ></b-form-radio-group>
              <div v-if="CloseTicketSelection == 'Yes'">
                <p>Please select a reason for Closure</p>
                <select
                  name="ClosureReason"
                  v-model="ClosureReason"
                  id="ClosureReason"
                >
                  <option value=""></option>
                  <option>Cancelled</option>
                  <option>No Longer Needed</option>
                </select>
              </div>
            </div> -->
            <br />
            <div>
              <b-button variant="outline-info" v-on:click="checkmodal()">
                Submit
              </b-button>
              <b-button variant="outline-info" v-on:click="resetModalActions()">
                Reset
              </b-button>
            </div>
          </b-card>
        </b-modal>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  computed: {
    rows() {
      return this.items.length;
    },
  },

  mounted() {
    let PostUrl =
      "https://fgnmkomagb.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/servicerequest";
    let PostHeaders = this.$apikeyPost;
    let PostData = {
      RequestType: "Location",
      Location: localStorage.getItem("CurrentLocation"),
      Status: "",
      AssignedTo: "",
      OriginalRequestType: "",
    };
    axios
      .post(PostUrl, PostData, PostHeaders)
      .then((response) => {
        this.testing = response.data.field_names;
        this.items = response.data.Values;
        for (let i = 0; i < this.testing.length; i++) {
          var QuoteStr = "" + i + "";
          this.ArrTest.push({ key: QuoteStr, label: this.testing[i] });
        }
        this.UserHeaders = this.ArrTest;
        this.UserHeaders.push("Action");
        this.ArrTest = [];
      })
      .catch((err) => {
        "ERROR: ====", err;
      });
  },

  data() {
    return {
      optionsUrgency: [
        { item: "Highly Urgent", name: "Highly Urgent (12hr)" },
        { item: "Urgent", name: "Urgent (24hr)" },
        { item: "Routine", name: "Routine (48hr)" },
        { item: "Non Urgent", name: "Non Urgent (1 Week)" },
      ],
      pickedDate: "2023-01-17",

      UserHeaders: [],
      items: [],
      response: null,
      ArrTest: [],
      RequestType: "",
      RequestStatus: "",
      RequestTeam: "",
      modal: false,
      perPage: 10,
      currentPage: 1,
      TicketobeActioned: "",
      TicketRaisedBy: "",
      TicketAssignedTo: "",
      Reason: "",
      UnitAction: "",
      Location: "",
      Status: "",
      checkedactions: [],
      options: [
        { item: "Yes", name: "Yes" },
        { item: "No", name: "No" },
      ],
      StatusUpdate: "",
      CloseTicketSelection: "No",
      ClosureReason: "",
      ServiceAssign: "",
      message: "",
      UserID: "",
      UserEmail: "",
      RequestDrop: "",
      userLocation: "",
      selected: "",
      userID: "",

      scheduledfields: [
        {
          key: "ServiceID",
          stickyColumn: true,
          isRowHeader: true,
          variant: "primary",
        },
        { key: "Location" },
        { key: "Room" },
        { key: "ServiceDescription" },
        { key: "ServiceType" },
        { key: "ArrangedBy" },
        { key: "ScheduledDate" },
        { key: "ScheduledTime" },
        { key: "Modify" },
      ],
      scheduleditems: [
        {
          ServiceID: "00000014",
          Location: "Ward Five",
          Room: "Room 4",
          ServiceDescription: "6 Monthly",
          ServiceType: "Routine C-1 Service",
          ArrangedBy: "Automated",
          ScheduledDate: "17/01/2023",
          ScheduledTime: "09:30:00",
        },
        {
          ServiceID: "00000015",
          Location: "Ward Six",
          Room: "Room 6",
          ServiceDescription: "3 Monthly",
          ServiceType: "Replace Biofilm Cartridge",
          ArrangedBy: "Automated",
          ScheduledDate: "19/01/2023",
          ScheduledTime: "16:00:00",
        },
        {
          ServiceID: "00000016",
          Location: "Maternity",
          Room: "Room 2",
          ServiceDescription: "6 Monthly",
          ServiceType: "Routine AG Handwash Unit Service",
          ArrangedBy: "Automated",
          ScheduledDate: "21/01/2023",
          ScheduledTime: "10:10:00",
        },
        {
          ServiceID: "00000017",
          Location: "Ward Two",
          Room: "Room 1",
          ServiceDescription: "Emergency",
          ServiceType: "Emergency C-1 Repairs",
          ArrangedBy: "Maddie Day",
          ScheduledDate: "23/01/2023",
          ScheduledTime: "11:45:00",
        },
      ],
    };
  },
  methods: {
    resetValue() {
      this.RequestType = "";
      this.RequestStatus = "";
      this.RequestTeam = "";
      let PostUrl =
        "https://fgnmkomagb.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/servicerequest";
      let PostHeaders = this.$apikeyPost;
      let PostData = {
        RequestType: "Location",
        Location: localStorage.getItem("CurrentLocation"),
        Status: "",
        AssignedTo: "",
        OriginalRequestType: "",
      };
      axios
        .post(PostUrl, PostData, PostHeaders)
        .then((response) => {
          this.testing = response.data.field_names;
          this.items = response.data.Values;
          for (let i = 0; i < this.testing.length; i++) {
            var QuoteStr = "" + i + "";
            this.ArrTest.push({ key: QuoteStr, label: this.testing[i] });
          }
          this.UserHeaders = this.ArrTest;
          this.UserHeaders.push("Action");
          this.ArrTest = [];
        })
        .catch((err) => {
          "ERROR: ====", err;
        });
    },

    SubmitFilter() {
      let PostUrl =
        "https://fgnmkomagb.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/servicerequest";
      let PostHeaders = this.$apikeyPost;

      if (
        this.RequestType == "" &&
        this.RequestStatus == "" &&
        this.RequestTeam == ""
      ) {
        alert("Please select a field to filter on");
      } else if (
        (this.RequestType != "" && this.RequestStatus != "") ||
        (this.RequestStatus != "" && this.RequestTeam != "") ||
        (this.RequestTeam != "" && this.RequestType != "")
      ) {
        alert("Please select only one field to filter on");
      } else if (this.RequestType != "") {
        let PostData = {
          RequestType: "OriginalRequestType",
          Status: "",
          AssignedTo: "",
          OriginalRequestType: this.RequestType,
        };

        axios
          .post(PostUrl, PostData, PostHeaders)
          .then((response) => {
            this.testing = response.data.field_names;
            this.items = response.data.Values;
            for (let i = 0; i < this.testing.length; i++) {
              var QuoteStr = "" + i + "";
              this.ArrTest.push({ key: QuoteStr, label: this.testing[i] });
            }
            this.UserHeaders = this.ArrTest;
            this.UserHeaders.push("Action");
            this.ArrTest = [];
          })
          .catch((err) => {
            "ERROR: ====", err;
          });
      } else if (this.RequestStatus != "") {
        let PostData = {
          RequestType: "Status",
          Status: this.RequestStatus,
          AssignedTo: "",
          OriginalRequestType: "",
        };
        axios
          .post(PostUrl, PostData, PostHeaders)
          .then((response) => {
            this.testing = response.data.field_names;
            this.items = response.data.Values;
            for (let i = 0; i < this.testing.length; i++) {
              var QuoteStr = "" + i + "";
              this.ArrTest.push({ key: QuoteStr, label: this.testing[i] });
            }
            this.UserHeaders = this.ArrTest;
            this.UserHeaders.push("Action");
            this.ArrTest = [];
          })
          .catch((err) => {
            "ERROR: ====", err;
          });
      } else if (this.RequestTeam != "") {
        let PostData = {
          RequestType: "AssignedTo",
          Status: "",
          AssignedTo: this.RequestTeam,
          OriginalRequestType: "",
        };
        axios
          .post(PostUrl, PostData, PostHeaders)
          .then((response) => {
            this.testing = response.data.field_names;
            this.items = response.data.Values;
            for (let i = 0; i < this.testing.length; i++) {
              var QuoteStr = "" + i + "";
              this.ArrTest.push({ key: QuoteStr, label: this.testing[i] });
            }
            this.UserHeaders = this.ArrTest;
            this.UserHeaders.push("Action");
            this.ArrTest = [];
          })
          .catch((err) => {
            "ERROR: ====", err;
          });
      }
      (this.RequestType = ""),
        (this.RequestStatus = ""),
        (this.RequestTeam = "");
    },

    showActionModal: function(
      ServiceID,
      RaisedBy,
      AssignedTo,
      Reason,
      UnitID,
      Location,
      status
    ) {
      this.TicketobeActioned = ServiceID;
      this.TicketRaisedBy = RaisedBy;
      this.TicketAssignedTo = AssignedTo;
      this.Reason = Reason;
      this.UnitAction = UnitID;
      this.Location = Location;
      this.Status = status;
      this.$refs["ServiceActionModal"].show(
        this.TicketobeActioned,
        this.TicketRaisedBy,
        this.TicketAssignedTo,
        this.Reason,
        this.UnitAction,
        this.Location,
        this.Status
      );
    },

    checkmodal() {
      if (this.checkedactions.length < 1) {
        alert("You must select at least one action");
      } else {
        if (
          this.checkedactions.includes("ChangeAssignee") &&
          this.checkedactions.includes("UpdateStatus") &&
          this.checkedactions.includes("CloseTicket")
        ) {
          alert("Please only select a change or close the ticket");
        } else if (
          this.checkedactions.includes("ChangeAssignee") ||
          this.checkedactions.includes("UpdateStatus")
        ) {
          this.LookUpRequest = {
            Actions: this.checkedactions,
            RequestID: this.TicketobeActioned,
            ServiceAssign: this.ServiceAssign,
            NewStatus: this.StatusUpdate,
          };
          let LookUpUrl =
            "https://88l7752c0h.execute-api.eu-west-2.amazonaws.com/" +
            this.$environment +
            "/service";
          let LookUpHeaders = this.$apikeyPost;
          this.LookUpRequest;
          axios
            .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
            .then((response) => {
              response;
              alert("Service Request has been updated");

              this.resetValue();
            })
            .catch((err) => {
              "Error: ===", err;
            });
        } else if (this.checkedactions.includes("CloseTicket")) {
          this.LookUpRequest = {
            Actions: this.checkedactions,
            RequestID: this.TicketobeActioned,
            ServiceAssign: this.ServiceAssign,
            NewStatus: this.ClosureReason,
          };
          let LookUpUrl =
            "https://88l7752c0h.execute-api.eu-west-2.amazonaws.com/" +
            this.$environment +
            "/service";
          let LookUpHeaders = this.$apikeyPost;

          axios
            .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
            .then((response) => {
              response;
              alert("Service Request has been closed");
              this.resetValue();
            })
            .catch((err) => {
              "Error: ===", err;
            });
        } else {
          alert("Issues");
        }

        this.$refs["ServiceActionModal"].hide();
        (this.checkedactions = []),
          (this.CloseTicketSelection = "No"),
          (this.StatusUpdate = ""),
          (this.ClosureReason = ""),
          (this.ServiceAssign = "");
      }
    },

    resetModalActions() {
      (this.checkedactions = []),
        (this.CloseTicketSelection = "No"),
        (this.StatusUpdate = ""),
        (this.ClosureReason = ""),
        (this.ServiceAssign = "");
    },
    showModal(Modal) {
      this.DivID = "";
      this.$refs[Modal].show();
    },
    modifyTestBooking() {
      this.showModal("ModifyServiceRequest");
    },
  },

  watch: {},
};
</script>
<style scoped>
input[type="text"],
select {
  width: 75%;
  padding: 5px 5px 5px 5px;
  border: solid 1px rgba(200, 200, 200, 0.5);
  background-color: rgb(245, 245, 245);
}
table[data-v-7d55f1d4] {
  font-size: 14px;
  color: black;
}

#HeadText {
  text-align: left;
  color: white;
}
</style>
